import {
    APP_INITIALIZER,
    EnvironmentProviders,
    Provider,
    inject,
} from '@angular/core';
//Angularfire
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { Auth, getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from 'environments/environment';

export const firebaseProvideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
         // Initialize Firebase
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),  
    ];
};

